import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { RestrictionQueryKey } from '../../queryKeys';
import {
  UseRestrictionByIdProps,
  UseRestrictionByIdQueryKeyProps,
} from './props';
import { Restriction } from '@/models/restriction';
import { fetchRestrictionById } from './service';
import { useEffect } from 'react';

export function useRestrictionById({
  id,
  externalOnSuccess,
}: UseRestrictionByIdProps) {
  const filter: { id: number } = {
    id: Number(id),
  };
  const queryKey: UseRestrictionByIdQueryKeyProps = [
    RestrictionQueryKey.ById,
    filter,
  ];

  const { data, isPending, error, refetch, fetchStatus } = useQuery<
    Restriction,
    AxiosError<GenericError>,
    Restriction,
    UseRestrictionByIdQueryKeyProps
  >({
    queryKey,
    queryFn: fetchRestrictionById,
    staleTime: 5 * 1000,
    enabled: !!id,
  });

  function handleExternalOnSuccess() {
    if (!externalOnSuccess || !data) {
      return;
    }

    externalOnSuccess(data);
  }

  useEffect(handleExternalOnSuccess, [data, externalOnSuccess]);

  return {
    restriction: data,
    isLoadingRestriction: isPending && fetchStatus != 'idle',
    errorRestriction: error,
    refetchRestriction: refetch,
  };
}
